import React from 'react';

export const REFERENCE_PANELS = [
	{ id: 'trek', label: 'Day-by-day', iconClass: 'fas fa-hiking', hint: 'Trail day reference', featured: true },
	{ id: 'packing', label: 'Packing', iconClass: 'fas fa-suitcase', hint: 'Gear checklist' },
	{ id: 'weather', label: 'Weather', iconClass: 'fas fa-cloud-sun', hint: 'Seasons & months' },
	{ id: 'documents', label: 'Documents', iconClass: 'fas fa-file-alt', hint: 'Papers to gather' },
	{ id: 'timeline', label: 'Timeline', iconClass: 'fas fa-calendar-alt', hint: 'When to book what' },
	{ id: 'budget', label: 'Budget', iconClass: 'fas fa-wallet', hint: 'Cost breakdown' },
	{ id: 'resources', label: 'Maps', iconClass: 'fas fa-map-marked-alt', hint: 'Offline GPS & downloads' },
	{ id: 'emergency', label: 'Safety', iconClass: 'fas fa-shield-alt', hint: 'Altitude & rescue' },
	{ id: 'faq', label: 'FAQs', iconClass: 'fas fa-question-circle', hint: 'Common questions' },
];

function JourneyPanelSwitcher({ activePanel, activeStep, onPanelChange, onGoToPrep }) {
	return (
		<div className="journey-switcher journey-switcher--kb-first">
			<div className="journey-switcher__hero">
				<div className="journey-switcher__hero-copy">
					<p className="journey-switcher__eyebrow">Trek knowledge base</p>
					<h2 className="journey-switcher__title">Day-by-day trail, packing, weather &amp; permits</h2>
					<p className="journey-switcher__lead">
						Start with the trail day-by-day, then packing, weather, and documents. Planning steps live below — they never replace this view.
					</p>
				</div>
			</div>

			<div className="journey-switcher__reference">
				<div className="journey-switcher__ref-scroll">
					<nav className="journey-switcher__ref-chips" aria-label="Trek knowledge">
						{REFERENCE_PANELS.map((p) => (
							<button
								key={p.id}
								type="button"
								className={`journey-switcher__ref-chip${activePanel === p.id ? ' is-active' : ''}${p.featured ? ' is-featured' : ''}`}
								onClick={() => onPanelChange(p.id)}
								aria-current={activePanel === p.id ? 'page' : undefined}
								title={p.hint}
							>
								<span className="journey-switcher__ref-icon" aria-hidden="true">
									<i className={p.iconClass} />
								</span>
								<span className="journey-switcher__ref-name">{p.label}</span>
							</button>
						))}
						<button
							type="button"
							className="journey-switcher__ref-chip journey-switcher__ref-chip--tasks"
							onClick={onGoToPrep}
							title={`Jump to preparation steps — currently ${activeStep.name}`}
						>
							<span className="journey-switcher__ref-icon" aria-hidden="true">
								<i className="fas fa-tasks" />
							</span>
							<span className="journey-switcher__ref-name">Tasks</span>
						</button>
					</nav>
				</div>
			</div>
		</div>
	);
}

export default JourneyPanelSwitcher;
